import { SVG } from './SVG';
const IconClinicalTrials = ({
  className,
  style,
  width,
  height,
  showBoxShadow = true,
  showBackground = true,
  color = 'white',
  padding = true,
}) => {
  const borderRadius = Math.min(width, height) * 0.25;
  const lineStyles = { stroke: color, strokeMiterlimit: '10', strokeLinecap: 'round', strokeLinejoin: 'round' };
  const otherColor = color === 'white' ? '#4062bb' : '#ffff';

  return (
    <div
      style={{
        ...(showBackground ? { background: 'linear-gradient(225deg, #4062BB 0%, #595FAA 100%)' } : {}),
        ...(showBoxShadow
          ? {
              borderRadius,
              boxShadow:
                '0px 50px 40px rgba(0, 0, 0, 0.07), 0px 20.8888px 16.711px rgba(0, 0, 0, 0.0503198), 0px 11.1682px 8.93452px rgba(0, 0, 0, 0.0417275), 0px 6.26078px 5.00862px rgba(0, 0, 0, 0.035), 0px 3.32505px 2.66004px rgba(0, 0, 0, 0.0282725), 0px 1.38363px 1.1069px rgba(0, 0, 0, 0.0196802)',
            }
          : {}),

        ...(padding
          ? {
              width,
              minWidth: width + 'px',
              height,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }
          : {}),
        ...style,
      }}
      className={className}
    >
      <SVG
        width={padding ? (32 / 52) * width : width}
        height={padding ? (36 / 52) * height : height}
        viewBox="0 0 32 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'relative', left: '1px' }}
      >
        <path d="M6.25403 3.17419L3.12256 6.30566L13.9849 17.168L17.1163 14.0365L6.25403 3.17419Z" {...lineStyles} />
        <path d="M3.63148 0.499871L0.5 3.63135L1.91895 5.0503L5.05043 1.91882L3.63148 0.499871Z" {...lineStyles} />
        <path d="M16.4909 14.6562L17.944 16.0402L16.0065 17.9777L14.6226 16.5246" {...lineStyles} />
        <path d="M2.79004 4.13818L4.03559 5.45293" {...lineStyles} />
        <path d="M4.17383 2.82324L5.41938 4.06879" {...lineStyles} />
        <path
          d="M10.3324 13.4797C12.0521 13.4797 13.4463 12.0856 13.4463 10.3658C13.4463 8.64608 12.0521 7.25195 10.3324 7.25195C8.61263 7.25195 7.21851 8.64608 7.21851 10.3658C7.21851 12.0856 8.61263 13.4797 10.3324 13.4797Z"
          fill={otherColor}
          {...lineStyles}
        />
        <path
          d="M10.3324 11.8879C11.1732 11.8879 11.8547 11.2064 11.8547 10.3656C11.8547 9.52484 11.1732 8.84326 10.3324 8.84326C9.49163 8.84326 8.81006 9.52484 8.81006 10.3656C8.81006 11.2064 9.49163 11.8879 10.3324 11.8879Z"
          fill={otherColor}
          {...lineStyles}
        />
        <path
          d="M21.9574 22.9598C20.5735 27.1808 16.6292 30.2255 11.9238 30.2255C9.08675 30.2255 6.45726 29.1184 4.45054 27.1117C2.44382 25.1049 1.33667 22.4754 1.33667 19.6384C1.33667 15.5557 3.68937 11.9575 7.08004 10.2275"
          {...lineStyles}
        />
        <path
          d="M8.32566 12.8569C7.63369 13.2029 7.01091 13.6873 6.45733 14.2409C3.41266 17.2856 3.41266 22.1294 6.45733 25.174C9.50201 28.2187 14.3458 28.2187 17.3905 25.174C18.0133 24.5513 18.5668 23.7901 18.9128 22.9597"
          {...lineStyles}
        />
        <path d="M24.3795 20.9531H16.9062V22.8906H24.3795V20.9531Z" {...lineStyles} />
        <path d="M18.7054 32.7856H5.00439V35H18.7054V32.7856Z" {...lineStyles} />
        <path d="M19.3281 19.7075H21.9576" {...lineStyles} />
        <path
          d="M14.8994 8.35884C16.5601 7.25168 18.4977 6.62891 20.6428 6.62891C26.3861 6.62891 31.0224 11.2651 31.0224 17.0085C31.0224 22.3367 27.0089 26.7653 21.8191 27.3189"
          {...lineStyles}
        />
        <path
          d="M14.3458 25.2427C11.8547 23.3744 10.2632 20.3297 10.2632 17.0082C10.2632 16.5931 10.2632 16.1779 10.3324 15.7627"
          {...lineStyles}
        />
        <path d="M8.74086 29.7412C8.74086 31.4019 7.42611 32.7167 5.76538 32.7167" {...lineStyles} />
        <path d="M14.9683 29.7412C14.9683 31.4019 16.283 32.7167 17.9437 32.7167" {...lineStyles} />
        <path d="M23.203 15.6248C24.2349 15.6248 25.0714 14.7884 25.0714 13.7565C25.0714 12.7247 24.2349 11.8882 23.203 11.8882C22.1712 11.8882 21.3347 12.7247 21.3347 13.7565C21.3347 14.7884 22.1712 15.6248 23.203 15.6248Z" />
        <path d="M23.2035 11.888V10.0889" {...lineStyles} />
        <path d="M23.2031 17.3548V15.5557" {...lineStyles} />
        <path d="M25.0022 13.7563H26.8013" {...lineStyles} />
        <path d="M19.5356 13.7563H21.3348" {...lineStyles} />
        <path d="M24.4487 12.4414L25.7635 11.1958" {...lineStyles} />
        <path d="M20.5737 16.3163L21.8885 15.0708" {...lineStyles} />
        <path d="M24.4487 15.0708L25.7635 16.3163" {...lineStyles} />
        <path d="M20.5735 11.1958L21.8882 12.4414" {...lineStyles} />
      </SVG>
    </div>
  );
};

/* eslint-disable react/display-name */
export { IconClinicalTrials as default, IconClinicalTrials };
